import React, { useState, useEffect } from "react";
import TextInput from "../TextInput/TextInput";
import { validateEmail } from "../utils/common";
import axios from "axios";
import styles from "./ChangeEmail.module.css";

const ChangeEmail = ({ editEmail, setEditEmail, businessEmail, setBusinessEmail, font }) => {
    const [emailError, setEmailError] = useState(null);
    const [confirmPassword, setConfirmPassword] = useState(false);
    const [userPasswordConfirm, setUserPasswordConfirm] = useState('');

    //verifies password and temprarily alters email field. User must still hit save changes for the change to persist
    const changeEmail = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("authToken");
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/verify_password/`,
                { password: userPasswordConfirm },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.status === 200) { setEditEmail("confirm_email"); }
            
        } catch (error) { setEmailError("Invalid password."); }
    };

    useEffect(() => {
        if (businessEmail && !validateEmail(businessEmail)) { setEmailError("Invalid email format."); } 
        else { setEmailError(null); }
        if (businessEmail && validateEmail(businessEmail)) { setEmailError(null); }
    }, [businessEmail]);

    return (
        <div className={styles.change_email_container}>
            {confirmPassword ? (
                    <form className={styles.confirm_email_change} onSubmit={changeEmail}>
                        <p className={`titles ${font}`}>Enter password to confirm</p>
                        {emailError && (<p className={`error_message ${styles.email_error}`}>{emailError}</p>)}
                        <div className={styles.change_password_wrapper}>
                            <TextInput inputType={"password"} value={userPasswordConfirm} onChange={(e) => setUserPasswordConfirm(e.target.value)} required={true} errors={emailError} />
                        </div>
                        <button className={`login_buttons ${styles.change_email_confirm} ${font}`} onClick={() => changeEmail} type="submit">Confirm</button>
                        <button className={`back_buttons ${styles.change_email_back_button}`} onClick={() => setConfirmPassword(false)}>
                             <img src={`${process.env.PUBLIC_URL}/images/back_button_arrow.png`} className={styles.change_email_back_button_arrow} alt="back"/>
                        </button>
                    </form>
            ) : (
                <>
                    <p className={`titles ${styles.new_email_title} ${font}`}>Enter new email</p>
                    {emailError && (<p className={`error_message ${styles.email_error}`}>{emailError}</p>)}
                    <div className={styles.change_email_wrapper}>
                        <TextInput inputType={"new_email"} value={businessEmail} onChange={(e) => setBusinessEmail(e.target.value)} required={false} errors={emailError} />
                    </div>
                    <button className={`login_buttons ${styles.change_email_continue} ${font}`} onClick={() => setConfirmPassword(true)} style={{opacity: emailError ? .3 : 1}} disabled={!!emailError}>Continue</button>
                    <button className={`back_buttons ${styles.change_email_back_button}`} onClick={() => setEditEmail(false)}>
                         <img src={`${process.env.PUBLIC_URL}/images/back_button_arrow.png`} className={styles.change_email_back_button_arrow} alt="back"/>
                    </button>
                </>
            )} 
        </div>
    );
};

export default ChangeEmail;